import { Theme } from '@yandex-int/k-common/typings';
import cx from 'classnames';
import { Text, useGeneratePath, useStaticUrls } from 'platform-components';
import React from 'react';
import { useLocation, useParams } from 'react-router';

import { LibraryBreadcrumbLink } from './__link/breadcrumb__link';

import './breadcrumb.scss';

interface Props {
    mix?: string;
    parentTheme: Theme | null;
}

export const LibraryBreadcrumb = ({ mix, parentTheme }: Props) => {
    const staticUrls = useStaticUrls();
    const generatePath = useGeneratePath();
    const { search } = useLocation();
    const params = useParams<Record<string, string>>();

    if (!parentTheme) {
        return null;
    }

    const parentThemeId = Number(parentTheme.id);
    const path = params?.classId ? staticUrls.labLibrarySubjectTheme : staticUrls.deepLabTheme;
    const link = `${generatePath(path, { themeId: parentThemeId })}${search}`;

    return (
        <div className={cx('library-breadcrumb', mix)}>
            <LibraryBreadcrumbLink to={link}>
                <Text size={Text.SIZE.XL} type={Text.TYPE.MARKDOWN} weight={Text.WEIGHT.M}>
                    {parentTheme.name}
                </Text>
            </LibraryBreadcrumbLink>
        </div>
    );
};

export { LibraryBreadcrumbActual } from './_actual/breadcrumb_actual';
export { LibraryBreadcrumbCalendarPlanShowcase } from './_calendar-plan-showcase/breadcrumb_calendar-plan-showcase';
export { LibraryBreadcrumbLink } from './__link/breadcrumb__link';
